import {CrossVisionObj} from '../../../allkeyme/workingzone/message/CrossVisionObj';
import {DataPackSet} from './DataPackSet';
import {EntityModificationTrace} from '../parameters/EntityModificationTrace';
import {FreeData} from '../../../allkeyme/core/message/FreeData';
import {FreeDataValue} from '../../../allkeyme/core/message/FreeDataValue';
import {SyncError} from './SyncError';
import {WorkCom} from '../../../allkeyme/workflow/message/WorkCom';

export class DataPack {
businessUnitCode: string;
compositeCreationMode: boolean;
connects: string[];
crossGenerated: boolean;
cvos: CrossVisionObj[];
datas: {[key: string]: {[key: string]: DataPackSet}};
deletedFreedataAndValues: EntityModificationTrace[];
deletedWorkCom: EntityModificationTrace[];
domain: string;
errorKind: string;
errors: SyncError[];
freedataRevisionNumber: number | null;
hasError: boolean;
hasRemoteUpdate: boolean;
inFreedata: FreeData;
inFreedataValues: FreeDataValue[];
inWorkComs: WorkCom[];
login: string;
manageFreedata: boolean | null;
originUuid: string;
remoteFreedata: FreeData[];
remoteFreedataValues: FreeDataValue[];
remoteWorkCom: WorkCom[];
status: string;
visionCode: string;
workcomRevisionNumber: number | null;
}

